import { Box, Card, IconButton, useTheme } from '@mui/material'

import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import CustomButton from '../../../../Components/CustomButton/CustomButton'
import WTypography from '../../../../Components/whiteTypography'
import { AppContext } from '../../../../context'
import ELogementBarChart from '../Charts/ELogementBarChart'
import ELogementDonut from '../Charts/ELogementDonut'
import BarCIcone from '../Icone/bar_chart_white_24dp.svg'
import DonutCIcone from '../Icone/donut_small_white_24dp.svg'
import HomeWorkIcon from '@mui/icons-material/HomeWork'
import EcoEmptyShortcut from './EcoEmptyShortcut'
function ELogementCard({ oldData }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const [optionChart, setOptionChart] = useState(false)
  const [reports, setReports] = useState()
  const [headerValue, setHeaderValue] = useState(null)
  const { tableAccount } = useContext(AppContext)
  const navigate = useNavigate()

  useEffect(() => {}, [oldData])
  const hasData = oldData?.[0]?.byimmo?.length > 0

  return (
    <Card className="dashboard_card__root1">
      <Box className="dashboard_card__header1">
        <WTypography component={'span'} variant="h6">
          {t('dashboard.emissionLogement') /* LAP-733 (GE022) */}
        </WTypography>
        <WTypography component={'span'} variant="h6">
          {headerValue}
          <WTypography
            component={'span'}
            sx={{ fontSize: '12px', color: 'white', marginLeft: '4px' }}
          >
            t. CO<sup>2</sup>/an
          </WTypography>
        </WTypography>
      </Box>

      <Box mt={3} minWidth={3} mb={6} height={'100%'} className="no-drag">
        {!hasData ? (
          <EcoEmptyShortcut
            icon={<HomeWorkIcon sx={{ fontSize: 31 }} />}
            description={t('dashboard.emptyLogementDesc') /* LAP-733 (GE022) */}
            to="/domicile/monimmobilier"
            buttonLabel={t('dashboard.emptyLogementBtn') /* LAP-733 (GE022) */}
          />
        ) : optionChart ? (
          <ELogementBarChart setHeaderValue={setHeaderValue} reports={reports ? reports : oldData} />
        ) : (
          <Box mt={10} className="chart_box" minWidth={3} mb={6} height={'100%'}>
            <ELogementDonut setHeaderValue={setHeaderValue} reports={reports ? reports : oldData} />
          </Box>
        )}
      </Box>

      {hasData && (
        <Box mt={2} className="dashboard_card__filters1">
          <Box className="no-drag">
            {optionChart ? (
              <IconButton onClick={() => setOptionChart(false)}>
                <img src={DonutCIcone} alt="DonutChart" className="Optionbutton"></img>
              </IconButton>
            ) : (
              <IconButton onClick={() => setOptionChart(true)}>
                <img src={BarCIcone} alt="BarChart" className="Optionbutton"></img>
              </IconButton>
            )}
          </Box>
        </Box>
      )}
    </Card>
  )
}

export default ELogementCard
